//Line 38 for changing the cart badge number.

/////////////////////////////////////////////
import { Avatar, AvatarBadge, Box, Flex, Text } from "@chakra-ui/react";

import { HiShoppingCart } from "react-icons/hi";

const CartButton = ({count}) => {  

  return (
    <>
      <Box
        bgColor={"rgb(255,255,255)"}
        _hover={{ bg: "rgb(255,255,255)" }}
        size="xs"
      >
        <Flex align={"center"}>
          <Avatar
            paddingLeft={"10px"}
            icon={<HiShoppingCart />}
            bg='"rgb(0,0,0)"'
            color={"black"}
            boxSize={"30px"}
            position="relative"
          >
          </Avatar>

          <Text
            color={"black"}
            fontSize="14px"
            fontWeight="bold"
            paddingLeft={"5px"}
          >
            Cart
          </Text>
        </Flex>
      </Box>
    </>
  );
};
export default CartButton;
